import { Controller } from "@hotwired/stimulus";
import Tabulator from "../lib/tabulator";

const CHECK_VALUES = { "": "All", "✓": "Owned", "✗": "Not owned" };
const RARITY_VALUES = {
  "": "All",
  C: "Common",
  U: "Uncommon",
  R: "Rare",
  M: "Mythic",
  S: "Special",
};

export default class extends Controller {
  connect() {
    const tableEl =
      this.element.tagName === "TABLE"
        ? this.element
        : this.element.querySelector("table");
    if (!tableEl) return;

    const rows = Array.from(tableEl.querySelectorAll("tbody tr")).map((row) => {
      const obj = {};
      Array.from(row.querySelectorAll("td")).forEach((td, i) => {
        obj[`c${i}`] = td.innerHTML;
      });
      return obj;
    });

    const columns = Array.from(tableEl.querySelectorAll("thead th")).map(
      (th, i) => {
        const col = {
          title: th.textContent.trim(),
          field: `c${i}`,
          formatter: "html",
          hozAlign: th.classList.contains("text-end") ? "right" : "left",
          headerHozAlign: th.classList.contains("text-end") ? "right" : "left",
          headerFilter: "input",
        };

        if (i === 0 || i === 1) {
          col.headerFilter = "list";
          col.headerFilterParams = { values: CHECK_VALUES, clearable: true };
          col.headerFilterFunc = (headerValue, rowValue) => {
            if (!headerValue) return true;
            return rowValue.trim() === headerValue;
          };
        }

        if (i === 3) {
          col.headerFilter = "list";
          col.headerFilterParams = { values: RARITY_VALUES, clearable: true };
          col.headerFilterFunc = (headerValue, rowValue) => {
            if (!headerValue) return true;
            return rowValue.trim().startsWith(headerValue);
          };
        }

        return col;
      }
    );

    this.tabulator = new Tabulator(tableEl, {
      data: rows,
      columns: columns,
      layout: "fitData",
    });
  }

  disconnect() {
    this.tabulator?.destroy();
  }
}
